import React, { useState } from "react";
import { MouseMonitor } from "../mouseMonitor";

interface Props {
    onMouseOver: (content: JSX.Element) => void;
    popupContent: JSX.Element;
    onMouseOut: () => void;
    children: JSX.Element;
}

export const Popup = ({
    onMouseOver,
    popupContent,
    onMouseOut,
    children,
}: Props) => {
    const [mouseIn, setMouseIn] = useState(false);

    const handleMouseOver = () => {
        setMouseIn(true);
        onMouseOver(
            <MouseMonitor
                onMoveAway={() => {
                    if (mouseIn) {
                        return;
                    }

                    onMouseOut();
                }}
                paddingX={60}
                paddingY={30}
            >
                {popupContent}
            </MouseMonitor>,
        );
    };

    const handleMouseOut = () => {
        setMouseIn(false);
    };

    return (
        <div
            onMouseOver={handleMouseOver}
            onFocus={handleMouseOver}
            onMouseOut={handleMouseOut}
            onBlur={handleMouseOut}
        >
            {children}
        </div>
    );
};